import React from 'react';

const ArrowIcon = () => (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="cls-1" d="M1.57001 15.47C1.19001 15.47 0.800005 15.32 0.510005 15.03C-0.0799951 14.44 -0.0799951 13.49 0.510005 12.91L5.61001 7.81L0.510005 2.71C-0.0799951 2.12 -0.0799951 1.17 0.510005 0.590003C1.1 0.0100031 2.05001 3.12924e-06 2.63001 0.590003L8.03001 5.99C9.03001 7 9.03001 8.62001 8.03001 9.62001L2.63001 15.02C2.34001 15.31 1.95001 15.46 1.57001 15.46V15.47Z" />
    </svg>
)

export default ArrowIcon;